import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';
import { PaymentField } from '../utils/models/PaymentField';

export function usePaymentFieldGet(props: { enabled?: boolean } = {}) {
  return useQuery<PaymentField[]>(
    [queryKeys.PAYMENT_FIELD],
    async () => {
      const res = await $api.get(endPoints.PAYMENT_FIELD);

      return res?.data?.data!;
    },
    {
      enabled: props.enabled,
      refetchOnWindowFocus: false,
      retry: false,
      onError: baseErrorHandler
    }
  );
}
